"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AuthActions = require("crm_data/auth/AuthActions");

var _2 = _interopRequireDefault(require("_"));

var _UserSettingsStore = _interopRequireDefault(require("crm_data/settings/UserSettingsStore"));

var _SettingsStore = _interopRequireDefault(require("crm_data/settings/SettingsStore"));

var _UserPortalSettingsKeys = _interopRequireDefault(require("crm_data/settings/UserPortalSettingsKeys"));

var _UserSettingsKeys = _interopRequireDefault(require("crm_data/settings/UserSettingsKeys"));

var SetupData = function SetupData(auth) {
  require('crm_data/gates/IsUngatedStore');

  require('crm_data/user/UserStore');

  require('crm_data/portal/PortalStore');

  (0, _AuthActions.authLoaded)(auth);

  _UserSettingsStore.default.get([].concat(_2.default.values(_UserPortalSettingsKeys.default), _2.default.values(_UserSettingsKeys.default)));

  _SettingsStore.default.get();
};

var _default = SetupData;
exports.default = _default;
module.exports = exports.default;